import { ref, onMounted, onBeforeUnmount } from "vue";

export function useSmartDropdown() {
  const dropdownVisible = ref(null);
  const dropdownDirection = ref("dropstart");
  const dropdownStyle = ref({});

  const closeDropdown = () => {
    dropdownVisible.value = null;
  };

  const toggleDropdown = (id, event) => {
    if (dropdownVisible.value === id) {
      closeDropdown();
      return;
    }

    if (event) {
      const button = event.currentTarget;
      const rect = button.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      const menuHeightEstimate = 200;
      const spaceBelow = windowHeight - rect.bottom;

      const isDropup = spaceBelow < menuHeightEstimate;

      dropdownDirection.value = isDropup ? "dropup" : "dropstart";

      dropdownStyle.value = {
        position: 'fixed',
        top: `${rect.top}px`,
        left: `${rect.left}px`,
        zIndex: 9999,
        '--button-rect-left': `${rect.left}px`,
        '--button-rect-top': `${rect.top}px`,
        '--button-rect-bottom': `${rect.bottom}px`,
      };

      dropdownVisible.value = id;
    }
  };

  const handleScroll = () => {
    if (dropdownVisible.value !== null) closeDropdown();
  };

  const handleGlobalClick = () => {
    closeDropdown();
  };

  onMounted(() => {
    document.addEventListener("click", handleGlobalClick);
    document.addEventListener("scroll", handleScroll, true);
    window.addEventListener("resize", closeDropdown);
  });

  onBeforeUnmount(() => {
    document.removeEventListener("click", handleGlobalClick);
    document.removeEventListener("scroll", handleScroll, true);
    window.removeEventListener("resize", closeDropdown);
  });

  return {
    dropdownVisible,
    dropdownDirection,
    dropdownStyle,
    toggleDropdown,
    closeDropdown
  };
}